import SimpleButton from "../Input/SimpleButton";
import { AiWrite, Download } from "../Icons/Interface";

interface FloatingGeneratingLabelProps {
	isLoading: boolean;
	isGenerating: boolean;
	onGenerate: () => void;
	contentLength: number;
	generateLabel: string;
	onDownload?: () => void;
}

/****
 * NOTE / TODO: This will become a Menubar, that contains, Download PDF, Copy to Clipboard.
 */

const FloatingGeneratingLabel = ({
	isLoading,
	isGenerating,
	onGenerate,
	contentLength,
	generateLabel,
	onDownload
}: FloatingGeneratingLabelProps) => {
	if (isLoading) return null;

	return (
		<>
			<div
				className="fixed bottom-96 left-1/2 transform -translate-x-1/2 translate-y-3/4 z-generating"
				id="MenuBar"
			>
				{isGenerating ? (
					<div className="animate-pulse bg-primary-accent text-primary border border-primary-active rounded-full px-6 py-2">
						Generating...
					</div>
				) : (
					<div className="flex gap-2">
						<SimpleButton
							onClick={onGenerate}
							className="bg-primary-active text-primary-accent rounded-full px-6 py-2 flex items-center gap-2"
						>
							{AiWrite()} {contentLength <= 0 ? generateLabel : "Regenerate"}
						</SimpleButton>
						{onDownload && contentLength > 0 && (
							<SimpleButton
								onClick={onDownload}
								className="bg-primary-active text-primary-accent rounded-full px-6 py-2 flex items-center gap-2"
							>
								{Download()} Download
							</SimpleButton>
						)}
					</div>
				)}
			</div>
		</>
	);
};

export default FloatingGeneratingLabel;
